const { makeStyles } = require('@material-ui/core')

const useStyles = makeStyles({
  backButton: {
    backgroundColor: '#fff',
    borderRadius: 8,
    border: '1px solid #ccc',
    cursor: 'pointer',
    fontSize: 14,
    padding: '10px 24px',
    marginBottom: 12
  },
  boxInfo: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'flex-start',
    padding: 20,
    width: '100%'
  },
  boxProduct: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    marginTop: 20,
    padding: 20,
    '& .MuiPaper-root': {
      boxShadow: 'none'
    }
  },
  itemImg: {
    width: 70,
    height: 70,
    objectFit: 'cover',
    flexShrink: 0,
    borderRadius: 4,
    padding: 6,
    border: '1px solid rgba(0, 0, 0, 0.23)'
  },
  itemInfoTable: {
    fontSize: 13,
    color: '#666',
    marginTop: 6,
    '& td': {
      padding: '1.5px 0'
    }
  }
})

export { useStyles }
